import classNames from 'classnames';
import { CurrencyHelpers } from 'helpers/currencyHelpers';
import { TYPOGRAPHY_CART_PRICE } from 'lib/typography';
import { Money } from 'types/entity/product';
import Typography from '../typography';

type Props = {
  price?: Money;
  locale: string;
  className?: string;
};

const Price: React.FC<Props> = ({ price, locale, className }) => {
  return (
    <Typography className={classNames(TYPOGRAPHY_CART_PRICE, className)}>
      {price && CurrencyHelpers.formatForCurrency(price, locale)}
    </Typography>
  );
};

export default Price;
